import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import './Sidebar.css';

interface SidebarProps {
  isOpen?: boolean;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen = true, onToggle }) => {
  const location = useLocation();
  const { canAccessModule, user } = usePermissions();
  
  const allMenuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard', module: null },
    { id: 'students', label: 'Students', icon: '👨‍🎓', path: '/students', module: 'students' },
    { id: 'guest-students', label: 'Guest Students', icon: '🧾', path: '/guest-students', module: 'students' },
    { id: 'student-sessions', label: 'Student Sessions', icon: '📊', path: '/student-sessions', module: 'students' },
    { id: 'therapists', label: 'Therapists', icon: '👨‍⚕️', path: '/therapists', module: 'therapists' },
    { id: 'schedules', label: 'Schedules', icon: '📅', path: '/schedules', module: 'schedules' },
    { id: 'document-transmittals', label: 'Document Transmittals', icon: '📄', path: '/document-transmittals', module: 'document-transmittals' },
    { id: 'fees-management', label: 'Fees Management', icon: '💰', path: '/fees-management', module: 'fees' },
    { id: 'accounting', label: 'Accounting', icon: '🧮', path: '/accounting', module: 'accounting' },
    { id: 'invoice', label: 'Invoice', icon: '🧾', path: '/invoice', module: 'invoices' },
    { id: 'pending-reports', label: 'Pending Reports', icon: '⚠️', path: '/pending-reports', module: 'pending-reports' },
    { id: 'reports', label: 'Reports', icon: '📈', path: '/reports', module: 'pending-reports' },
    { id: 'users', label: 'User Management', icon: '👥', path: '/users', module: 'users' },
    { id: 'settings', label: 'Settings', icon: '⚙️', path: '/settings', module: 'settings' },
    { id: 'backup', label: 'Backup', icon: '💾', path: '/backup', module: '__superadmin__' },
  ];

  // Filter menu items based on permissions
  const menuItems = allMenuItems.filter(item => {
    if (!item.module) return true; // Always show dashboard
    if (item.module === '__superadmin__') return !!user?.is_superadmin;
    return canAccessModule(item.module);
  });

  return (
    <aside className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.id} className="sidebar-menu-item">
              <Link 
                to={item.path} 
                className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="sidebar-icon">{item.icon}</span>
                {isOpen && <span className="sidebar-label">{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
